import Masonry from "masonry-layout";

export function commonFunc() {
const grid = document.querySelector('.grid')
const msnry = new Masonry(grid, {
  itemSelector: '.zine-loop__item',
  columnWidth: '.grid-sizer',
  percentPosition: true,
  gutter: 0,
  horizontalOrder: true,
  transitionDuration: '0.8s'
});

$('#search-modal-toggle').on('click', function() {
  $('#search-modal').toggleClass('open');
});
}